import React, { useState } from "react";
import { Grid, CircularProgress, Typography, Button, Tabs, Tab, TextField, Fade } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import classnames from "classnames";
// styles
import useStyles from "./styles";

// logo
import logo from "./logo.svg";

// context
import { useUserDispatch, loginUser } from "../../context/UserContext";
import Cookies from "universal-cookie";
function Login(props) {
	var classes = useStyles();

	// global
	var userDispatch = useUserDispatch();

	// local
	var [isLoading, setIsLoading] = useState(false);
	var [error, setError] = useState(null);
	var [activeTabId, setActiveTabId] = useState(0);
	var [nameValue, setNameValue] = useState("");
	var [loginValue, setLoginValue] = useState("");
	var [passwordValue, setPasswordValue] = useState("");

	return (
		<Grid container className={classes.container}>
			<div className={classes.logotypeContainer}>
				<img
					src={require("../../images/loghi/bianco_trasparente.png")}
					style={{
						width: "90%",
						marginBottom: "20px",
						marginTop: "20px",
					}}
				/>
			</div>
			<div className={classes.formContainer}>
				<div className={classes.form}>
					<Tabs
						value={activeTabId}
						onChange={(e, id) => setActiveTabId(id)}
						indicatorColor="primary"
						textColor="primary"
						centeredfrree
					>
						<Tab label="Login" classes={{ root: classes.tab }} />
					</Tabs>
					{activeTabId === 0 && (
						<React.Fragment>
							<Typography variant="h1" className={classes.greeting}>
								Welcome
							</Typography>
							<Fade in={error}>
								<Typography color="secondary" className={classes.errorMessage}>
									Something is wrong with your login or password :(
								</Typography>
							</Fade>
							<TextField
								id="email"
								InputProps={{
									classes: {
										underline: classes.textFieldUnderline,
										input: classes.textField,
									},
								}}
								value={loginValue}
								onChange={e => setLoginValue(e.target.value)}
								margin="normal"
								placeholder="Email Adress"
								type="email"
								fullWidth
							/>
							<TextField
								id="password"
								InputProps={{
									classes: {
										underline: classes.textFieldUnderline,
										input: classes.textField,
									},
								}}
								value={passwordValue}
								onChange={e => setPasswordValue(e.target.value)}
								margin="normal"
								placeholder="Password"
								type="password"
								fullWidth
							/>
							<div className={classes.formButtons}>
								{isLoading ? (
									<CircularProgress size={26} className={classes.loginLoader} />
								) : (
									<Button
										disabled={loginValue.length === 0 || passwordValue.length === 0}
										onClick={async () => {
											await loginUser(
												userDispatch,
												loginValue,
												passwordValue,
												props.history,
												setIsLoading,
												setError
											);
										}}
										variant="contained"
										color="primary"
										size="large"
									>
										Login
									</Button>
								)}
							</div>
						</React.Fragment>
					)}
					{activeTabId === 1 && (
						<React.Fragment>
							<Typography variant="h1" className={classes.greeting}>
								Benvenuto!
							</Typography>
							<Typography variant="h2" className={classes.subGreeting}>
								Crea il tuo account
							</Typography>
							<Fade in={error}>
								<Typography color="secondary" className={classes.errorMessage}>
									Something is wrong with your login or password :(
								</Typography>
							</Fade>
							<TextField
								id="name"
								InputProps={{
									classes: {
										underline: classes.textFieldUnderline,
										input: classes.textField,
									},
								}}
								value={nameValue}
								onChange={e => setNameValue(e.target.value)}
								margin="normal"
								placeholder="Full Name"
								type="text"
								fullWidth
							/>
							<TextField
								id="email"
								Inputops={{
									classes: {
										underline: classes.textFieldUnderline,
										input: classes.textField,
									},
								}}
								value={loginValue}
								onChange={e => setLoginValue(e.target.value)}
								margin="normal"
								placeholder="Email Adress"
								type="email"
								fullWidth
							/>
							<TextField
								id="password"
								InputProps={{
									classes: {
										underline: classes.textFieldUnderline,
										input: classes.textField,
									},
								}}
								value={passwordValue}
								onChange={e => setPasswordValue(e.target.value)}
								margin="normal"
								placeholder="Password"
								type="password"
								fullWidth
							/>
							<div className={classes.creatingButtonContainer}>
								{isLoading ? (
									<CircularProgress size={26} />
								) : (
									<Button
										onClick={async () => {}}
										disabled={
											loginValue.length === 0 ||
											passwordValue.length === 0 ||
											nameValue.length === 0
										}
										size="large"
										variant="contained"
										color="primary"
										fullWidth
										className={classes.createAccountButton}
									>
										Create your account
									</Button>
								)}
							</div>
						</React.Fragment>
					)}
				</div>
				<Typography color="primary" className={classes.copyright}>
					© 2021-2022 Accademia Nazionale del Cinema. All rights reserved.
				</Typography>
			</div>
		</Grid>
	);
}

export default withRouter(Login);
